import { Link } from "react-router-dom";
import BuyerPublicNavbar from "@/components/BuyerPublicNavbar";
import Footer from "@/components/Footer";

export default function TermsAndConditionsPage() {
  return (
    <div className="min-h-screen bg-white">
      <BuyerPublicNavbar />

      <section className="bg-neutral-900 text-white py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight uppercase">Terms &amp; Conditions</h1>
          <p className="mt-3 text-neutral-400 text-sm">Last updated: January 2025</p>
        </div>
      </section>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="prose prose-neutral max-w-none">

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">1. Company Information</h2>
            <p className="text-neutral-600 leading-relaxed">
              SCAFFO INDIA operates through its website located at <strong>www.scaffoindia.com</strong> (hereinafter referred to as the &ldquo;Platform&rdquo; or &ldquo;Website&rdquo;). The platform is owned and managed by <strong>Scaffoindia Private Limited</strong>, a company registered under the laws of India, with its registered office located at <strong>Vipul Business Park, Sector 48, Gurugram, Haryana, India</strong>.
            </p>
            <p className="text-neutral-600 leading-relaxed mt-3">
              For any questions or concerns regarding these Terms, please contact us at:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-1 mt-2">
              <li>Email: <strong>Scaffoindia@gmail.com</strong></li>
              <li>Phone: <strong>+91-89208 93912</strong></li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">2. Acceptance of Terms</h2>
            <p className="text-neutral-600 leading-relaxed">
              By accessing or using the SCAFFO INDIA Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions (&ldquo;Terms&rdquo;). If you do not agree to these Terms, please refrain from using the Platform. Your continued use of the Platform constitutes your acceptance of these Terms.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">3. Service Description</h2>
            <p className="text-neutral-600 leading-relaxed">
              SCAFFO INDIA serves as an intermediary platform that connects buyers with scaffolding requirements (&ldquo;Buyers&rdquo;) with verified scaffolding suppliers and service providers (&ldquo;Suppliers&rdquo;). Our services include facilitating the exchange of requirements, lead management, and providing a structured quotation system. SCAFFO INDIA does not itself provide scaffolding products or services, and all transactions occur directly between Buyers and Suppliers.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">4. Buyer Obligations</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              As a Buyer, you agree to:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>Provide accurate, current, and complete information when submitting requirements.</li>
              <li>Ensure that the contact information provided (phone number and email address) is valid and accessible.</li>
              <li>Respond to communications from Suppliers in a timely manner.</li>
              <li>Engage with Suppliers in good faith and consider quotations objectively.</li>
              <li>Not use the Platform for any fraudulent, illegal, or unauthorized purposes.</li>
              <li>Accept that SCAFFO INDIA reserves the right to reject requirements that do not meet our acceptance criteria.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">5. Lead Acceptance Criteria</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              To maintain platform integrity, SCAFFO INDIA may accept or reject leads based on the following criteria:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>Completeness of requirement details.</li>
              <li>Validity and accessibility of contact information.</li>
              <li>Authenticity of the buyer&apos;s identity and intent.</li>
              <li>Compliance with applicable laws and platform policies.</li>
              <li>Prevention of spam, duplicate, or malicious submissions.</li>
            </ul>
            <p className="text-neutral-600 leading-relaxed mt-3">
              We reserve the right to reject leads that do not meet these criteria without providing a reason.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">6. Supplier Obligations</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              As a Supplier, you agree to:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>Maintain accurate and up-to-date business information on the Platform.</li>
              <li>Provide genuine, competitive, and timely quotations to Buyers.</li>
              <li>Honor the terms of quotations once accepted by the Buyer.</li>
              <li>Comply with all applicable laws, regulations, and industry standards.</li>
              <li>Not engage in deceptive, fraudulent, or misleading practices.</li>
              <li>Respond to assigned leads within a reasonable timeframe.</li>
              <li>Maintain the confidentiality of Buyer information shared through the Platform.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">7. Quotation Terms</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              Quotations submitted by Suppliers through the SCAFFO INDIA Platform are binding offers. The following terms apply:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>Quotations must include itemized pricing, terms, and conditions.</li>
              <li>Prices quoted are exclusive of applicable taxes unless stated otherwise.</li>
              <li>Quotations must specify the validity period.</li>
              <li>Terms such as delivery schedule, payment terms, and warranty must be clearly stated.</li>
              <li> SCAFFO INDIA is not responsible for disputes arising from quotations; however, we may mediate if necessary.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">8. Price Validity</h2>
            <p className="text-neutral-600 leading-relaxed">
              All prices quoted by Suppliers are valid for the period specified in the quotation. After the validity period expires, Suppliers reserve the right to revise prices. SCAFFO INDIA does not guarantee price stability and recommends that Buyers confirm current pricing before proceeding with orders.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">9. Delivery and Installation</h2>
            <p className="text-neutral-600 leading-relaxed">
              Delivery timelines and installation services are as per the terms agreed upon between the Buyer and the Supplier. SCAFFO INDIA facilitates communication but is not liable for delays, damages, or non-performance related to delivery or installation. Buyers are advised to include specific delivery and installation requirements in their quotations.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">10. Cancellation Policy</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              Cancellations are subject to the terms agreed upon between the Buyer and Supplier. General guidelines:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>Buyers may cancel requirements before a Supplier accepts the quotation without penalty.</li>
              <li>After a quotation is accepted, cancellation terms depend on the Supplier&apos;s stated policy.</li>
              <li>Suppliers may withdraw quotations before acceptance without liability.</li>
              <li>SCAFFO INDIA is not responsible for any losses arising from cancellations but may assist in dispute resolution.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">11. Payment Terms</h2>
            <p className="text-neutral-600 leading-relaxed">
              Payments are processed directly between Buyer and Supplier. SCAFFO INDIA does not handle or process payments through the Platform. Payment terms, including advances, installments, and final settlements, must be agreed upon directly by the parties involved. SCAFFO INDIA recommends using secure payment methods and maintaining proper transaction records.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">12. Warranty</h2>
            <p className="text-neutral-600 leading-relaxed">
              Warranty terms for scaffolding products and services are as provided by the respective Suppliers. SCAFFO INDIA does not provide, imply, or guarantee any warranty for products or services transacted through the Platform. Buyers should review and confirm warranty terms directly with Suppliers before making purchases.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">13. Limitation of Liability</h2>
            <p className="text-neutral-600 leading-relaxed">
              To the maximum extent permitted by applicable law, SCAFFO INDIA shall not be held liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities, arising from or related to the use of the Platform or transactions between Buyers and Suppliers. SCAFFO INDIA&apos;s total liability shall not exceed the amount of fees paid by the user to SCAFFO INDIA in the twelve (12) months preceding the claim.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">14. Intellectual Property</h2>
            <p className="text-neutral-600 leading-relaxed">
              All content, design, logos, trademarks, and intellectual property on the SCAFFO INDIA Platform are owned by SCAFFO INDIA or its licensors and are protected under applicable intellectual property laws. Unauthorized copying, modification, distribution, or exploitation of any Platform content is strictly prohibited.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">15. Force Majeure</h2>
            <p className="text-neutral-600 leading-relaxed">
              SCAFFO INDIA shall not be liable for any failure or delay in performing its obligations due to events beyond its reasonable control, including natural disasters, acts of war, pandemics, government actions, or infrastructure failures. In such cases, the affected party will notify the other party promptly, and obligations will be suspended for the duration of the force majeure event.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">16. Governing Law</h2>
            <p className="text-neutral-600 leading-relaxed">
              These Terms and Conditions are governed by and construed in accordance with the laws of India. Any disputes arising from or relating to these Terms shall be subject to the exclusive jurisdiction of the courts in Gurugram, Haryana, India.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">17. Dispute Resolution</h2>
            <p className="text-neutral-600 leading-relaxed mb-3">
              In the event of any dispute between Buyer and Supplier:
            </p>
            <ul className="list-disc list-inside text-neutral-600 space-y-2">
              <li>The parties should first attempt to resolve the dispute through mutual negotiation.</li>
              <li>If negotiation fails, the matter may be referred to mediation under the provisions of the Arbitration and Conciliation Act, 1996.</li>
              <li>If mediation fails, the dispute shall be resolved through arbitration in Gurugram, Haryana, India.</li>
              <li>The language of arbitration proceedings shall be English.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-4">18. Amendment</h2>
            <p className="text-neutral-600 leading-relaxed">
              SCAFFO INDIA reserves the right to modify, update, or replace these Terms at any time without prior notice. Any changes will be effective immediately upon posting on the Platform. Your continued use of the Platform after any changes constitutes your acceptance of the revised Terms. We encourage users to review these Terms periodically.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-neutral-200">
          <Link
            to="/"
            className="inline-flex items-center text-sm text-orange-600 font-semibold hover:underline"
          >
            &larr; Back to Home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}